import { ActionTypes } from "../constants/actions";

export const setLoaderVisibility = (payload: boolean) => ({
  payload,
  type: ActionTypes.COMMON.SET_LOADER_VISIBILITY,
});

export const closeToaster = () => ({
  payload: {
    data: "",
    success: true,
    visible: false,
  },
  type: ActionTypes.COMMON.SET_TOASTER_VISIBILITY,
});

export const openToaster = (message: string, success: boolean) => ({
  payload: {
    data: message,
    success,
    visible: true,
  },
  type: ActionTypes.COMMON.SET_TOASTER_VISIBILITY,
});

export const loggedIn = (isLoggedIn: boolean) => ({
  type: ActionTypes.COMMON.IS_LOGGED_IN,
  payload: isLoggedIn,
});

export const actionAllowFetchGridData = (allow: boolean) => ({
  type: ActionTypes.COMMON.ALLOW_FETCH_GRID_DATA,
  payload: allow,
});

export const closeConfirmDialog = () => ({
  payload: {
    open: false,
    title: "",
    content: "",
    key: "",
  },
  type: ActionTypes.COMMON.SET_CONFRIM_DAILOG_VISIBILITY,
});

export const openConfirmDialog = (dialog: any) => ({
  payload: {
    open: true,
    title: dialog.title,
    content: dialog.content,
    key: dialog.key,
  },
  type: ActionTypes.COMMON.SET_CONFRIM_DAILOG_VISIBILITY,
});

export const okConfirmDialog = () => ({
  type: ActionTypes.COMMON.CONFIRM_DIALOG_OK,
});

export const setTitle = (title: string) => ({
  payload: {
    data: title,
  },
  type: ActionTypes.COMMON.SET_PAGE_TITLE,
});